import React from 'react';
import PropTypes from 'prop-types';
import { Space, Grid, Typography } from '@pitchero/react-ui';
import PROFILES_PROP_TYPES from '../../../lib/prop-types/profile';
import Profile from './profile';

const ProfileGroup = ({ teamId, title, profiles }) => (
  <Space bottom="xxlarge" component="div">
    <Space bottom="medium" component="div">
      <Typography preset="title" color="black" transform="uppercase">
        {title}
      </Typography>
    </Space>
    <Grid preset="profiles">
      {profiles.map((profile) => (
        <Profile key={`${profile.profile_type}-${profile.id}`} teamId={teamId} {...profile} />
      ))}
    </Grid>
  </Space>
);

ProfileGroup.defaultProps = {
  profiles: [],
};

ProfileGroup.propTypes = {
  teamId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  profiles: PROFILES_PROP_TYPES,
};

export default ProfileGroup;
